module.exports = __webpack_public_path__ + "img/ch09_14_星辰柄.156573ea.jpg";